import type { MapDispatchToPropsFunction, MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { batchFormReloadRequestedThunk, batchResetWorkspaceTabThunk } from 'state/batchForm/batchForm.thunks';
import {
  canImportQuotesToBatchTab,
  getBatchProductSubType,
  getBatchProductType,
  getBatchWrapper,
} from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';

import type {
  BatchToolbarWorkspaceActionsDispatchProps,
  BatchToolbarWorkspaceActionsOwnProps,
  BatchToolbarWorkspaceActionsStateProps,
  BatchToolbarWorkspaceActionTrigger,
} from './BatchToolbarWorkspaceActions.models';

export const mapStateToProps: MapStateToProps<
  BatchToolbarWorkspaceActionsStateProps,
  BatchToolbarWorkspaceActionsOwnProps,
  AppState
> = (state: AppState, ownProps: BatchToolbarWorkspaceActionsOwnProps): BatchToolbarWorkspaceActionsStateProps => ({
  canImportQuotes: canImportQuotesToBatchTab(state, ownProps.tabId),
  productSubtype: getBatchProductSubType(state, ownProps.tabId),
  productType: getBatchProductType(state, ownProps.tabId),
  wrapper: getBatchWrapper(state, ownProps.tabId),
  tabId: ownProps.tabId,
});

export const mapDispatchToProps: MapDispatchToPropsFunction<
  BatchToolbarWorkspaceActionsDispatchProps,
  BatchToolbarWorkspaceActionsOwnProps
> = (
  dispatch: ThunkDispatch,
  ownProps: BatchToolbarWorkspaceActionsOwnProps,
): BatchToolbarWorkspaceActionsDispatchProps => ({
  onReset(trigger: BatchToolbarWorkspaceActionTrigger = 'button') {
    logAnalytics.trackEvent(
      'Batch Workspace',
      trigger === 'shortcut' ? 'Reset current tab (Ctrl+Backspace)' : 'Reset tab from header',
    );
    dispatch(batchResetWorkspaceTabThunk(ownProps.tabId));
  },
  onImported(identifiers: string[]) {
    dispatch(batchFormReloadRequestedThunk(ownProps.tabId, identifiers));
  },
});

export const connectedBatchToolbarWorkspaceActions = connect<
  BatchToolbarWorkspaceActionsStateProps,
  BatchToolbarWorkspaceActionsDispatchProps,
  BatchToolbarWorkspaceActionsOwnProps,
  AppState
>(mapStateToProps, mapDispatchToProps);
